export {default} from "./Intro";
